import React, { useState, useEffect } from 'react';
import { FaVolumeUp, FaRegCopy, FaRegThumbsUp, FaRegThumbsDown, FaCheck, FaStopCircle, FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im'; // Spinner icon
import useAudioPlayer from '../hooks/useAudioPlayer';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';
import { hooks } from "botframework-webchat-component";

const { useActivities, useSendEvent } = hooks;
const ActionButtons = ({ activity, text, id, script,responseGood }) => {
  const [activities] = useActivities();
  const sendEvent = useSendEvent();

  const [copied, setCopied] = useState(false);
  const [isLoading, isPlaying, isInterrupted, playAudio, stopAudio] = useAudioPlayer(id);
  const [selectedAction, setSelectedAction] = useState(null);
  if (!text){
    text =script
  }
  // Enhanced logging for debugging
  useEffect(() => {
    console.log(`Audio States for ID ${id} - isPlaying: ${isPlaying}, isInterrupted: ${isInterrupted}, isLoading: ${isLoading}`);
  }, [isPlaying, isInterrupted, isLoading, id]);

  const handleActionClick = (actionType) => {
    console.log(`Action clicked: ${actionType} for ID: ${id}`);

    switch (actionType) {
      case 'thumbsUp':
        setSelectedAction('thumbsUp');
        sendEvent('ThumbsUp', id);
        console.log(`Thumbs up for text: "${text}"`);
        break;

      case 'thumbsDown':
        setSelectedAction('thumbsDown');
        sendEvent('ThumbsDown', id);
        console.log(`Thumbs down for text: "${text}"`);
        break;

      case 'copy':
        navigator.clipboard.writeText(text);
        setCopied(true);
        console.log(`Copied text: "${text}"`);
        setTimeout(() => setCopied(false), 5000);
        break;

      case 'readAloud':
        console.log('Read Aloud action triggered.');
        if (isPlaying || isLoading) {
          console.log(`Stopping audio playback for ID: ${id}`);
          stopAudio();
        } else {
          const cleanedText = text
            .replace(/<\/?[^>]+(>|$)/g, '') // Remove HTML tags
            .replace(/[#*_~`]/g, '') // Remove markdown symbols
            .replace(/[\u{1F300}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E6}-\u{1F1FF}]/gu, '') // Remove emojis
            .replace(/https?:\/\/[^\s]+/g, ''); // Remove URLs

          console.log(`Playing audio for cleaned text: "${cleanedText}"`);
          playAudio(cleanedText);
        }
        break;

      default:
        console.log(`Unknown action: ${actionType}`);
        break;
    }
  };

  return (
    <div className="mt-2 flex space-x-3" style={{ direction: 'ltr', textAlign: 'left' }}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button onClick={() => handleActionClick('thumbsUp')} className="text-gray-500 p-1">
              {responseGood === 1 ? <FaThumbsUp className="w-4 h-5" /> : <FaRegThumbsUp className="w-4 h-5" />}
            </button>
          </TooltipTrigger>
          <TooltipContent>Good response</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <button onClick={() => handleActionClick('thumbsDown')} className="text-gray-500 p-1">
              {responseGood === -1 ? <FaThumbsDown className="w-4 h-5" /> : <FaRegThumbsDown className="w-4 h-5" />}
            </button>
          </TooltipTrigger>
          <TooltipContent>Bad response</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <button onClick={() => handleActionClick('copy')} className="text-gray-500 p-1">
              {copied ? <FaCheck className="w-4 h-5" /> : <FaRegCopy className="w-3 h-4" />}
            </button>
          </TooltipTrigger>
          <TooltipContent>{copied ? 'Copied!' : 'Copy'}</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <button onClick={() => handleActionClick('readAloud')} className="text-gray-500 p-1">
              {isLoading ? (
                <ImSpinner2 className="w-4 h-5 animate-spin" />
              ) : isPlaying && !isInterrupted ? (
                <FaStopCircle className="w-4 h-5" />
              ) : (
                <FaVolumeUp className="w-4 h-5" />
              )}
            </button>
          </TooltipTrigger>
          <TooltipContent>
            {isLoading ? 'Loading Audio...' : isPlaying ? 'Stop Reading' : 'Read Aloud'}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default ActionButtons;
